// removed by extract-text-webpack-plugin
module.exports = {"formContainer":"src-components-EmailForm----emailform-module---formContainer---3nYO3","input":"src-components-EmailForm----emailform-module---input---37xMV","button":"src-components-EmailForm----emailform-module---button---2Hs3Q","leftCol":"src-components-EmailForm----emailform-module---leftCol---2wHlk","rightCol":"src-components-EmailForm----emailform-module---rightCol---3sCKY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/EmailForm/emailform.module.css
// module id = 380
// module chunks = 114276838955818